import {useEffect, useState, useRef, useCallback} from "react";
import ImageGalleryService from "./ImageGalleryService";
import State from "../State";
import './ImageGallery.css';


export default function ImageGallery() {

	const [state] = useState(new State(useState(0)));
	const service = new ImageGalleryService(state);

	const measuredRef = useCallback(node => {    if (node !== null) {
		console.log("measuredRef "+window.innerWidth);
		service.calculatePositions(window);
	}  }, []);

	const divRef = useRef(null);
	const resizeIframe = () => {
		console.log("resizeIframe "+window.innerWidth);
		service.calculatePositions(window);
	};
	useEffect(() => {
		service.calculatePositions(window);
		const onResize = () => {
			console.log('init resize');
			resizeIframe();
		}

		window.addEventListener("resize", onResize);

		return () => {
			window.removeEventListener("resize", onResize);
		}
	}, []);

	function mergeRefs(...inputRefs) {
		return (ref) => {
			inputRefs.forEach((inputRef) => {
				if (!inputRef) {
					return;
				}

				if (typeof inputRef === 'function') {
					inputRef(ref);
				} else {
					// eslint-disable-next-line no-param-reassign
					inputRef.current = ref;
				}
			});
		};
	}



	useEffect(() => {
		service.fetchImages()
		const interval = setInterval(() => {
				service.fetchImages();
			}
			, 60000);
		return () => clearInterval(interval);
	}, []);

	useEffect(() => {
		const interval = setInterval(() => {
				service.next()
			}
			, 10000);
		return () => clearInterval(interval);
	}, []);



	if (state.loading) {
		return (<>Hämtar bilder...</>)
	}

	if (state.images.length === 0) {
		return (<>Inga bilder...</>)
	}

	const currentImg = state.images[state.current];

const img = service.graphQL.jsonApi.baseUrl + currentImg.fullpath;

return (<>
	{state.message}
	<h1>{currentImg.title} </h1>


	<div ref={mergeRefs(divRef, measuredRef)}>
		<span style={{cursor: 'pointer'}} onClick={() => service.prev()}>⬅️</span>
		<img src={img} width={state.width} height={state.height}/>
		<span style={{cursor: 'pointer'}} onClick={() => service.next()}>➡️</span>
	</div>
	<span className="imgDescsription">{currentImg.description}</span>
	<span className="imgCopyright">©️{currentImg.copyright} {state.current + 1}/{state.images.length}</span>
</>);

}
